import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import Select from 'react-select';
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { RotatingLines } from "react-loader-spinner";
import { PieChart } from "react-minimal-pie-chart";
import CircularProgress from '@mui/material/CircularProgress';
import $ from "jquery";
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { Chart } from "react-google-charts";
import { handleError } from "../../services/authApiRoutes/APImethods";
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
})); 

export default function ReportFile() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const [activeTab, setActiveSection] = useState("ProjectDashboard");
  const[globalOverlay,showGlobalOverlay] = useState(true);
  const [reportProjectStatus,setReportProjectStatus]=useState([])
  const [reportProjectStatusCount,setReportProjectStatusCount]=useState([])

  const [reviewerReportStatus,setReviewerReportStatus]=useState([])
  const [reviewerReportOptions,setReviewerReportOptions]=useState([])
  const [workItemOptions,setWorkItemOptions]=useState([])
  const [languageStatus,setLanguageStatus]=useState([])
  const [feedBackReportStatus,setFeedBackReportStatus]=useState([])
  const [feedBackReportOptions,setFeedBackReportOption]=useState({})
  const [languageStatusTracker,setLanguageStatusTracker]=useState([])
  const [assestByLanguageStatus,setAssestByLanguageStatus]=useState([])
  const [reportsVendorStatus,setReportsVendorStatus]=useState([])
  const [intendedUseStatus,setIntendedUseStatus]=useState([])
  const [intendedUseCount,setIntendedUseCount]=useState([])
  const [workItemStatus,setWorkItemStatus]=useState([])
  const [tmProjectReportStatus,setTmProjectReportStatus]=useState([])
  const [tmProjectReportCount,setTmProjectReportCount]=useState([])
  const [totalWordCountByLanguageStatus,setTotalWordCountByLanguageStatus]=useState([])
  const [purchaseOrderStatus,setPurchaseOrderStatus]=useState([])
  const [totalCostSaving,setTotalCostSavingCount]=useState([])
  const [purchaseOrderDataInvoice,setPurchaseOrderInvoic]=useState([])
  const [sourceLanguage,setSourceLanguage]=useState([])
  const [targetLanguage,setTargetLanguage]=useState([])
  const [projectReportAssetsCount,setProjectReportAssetsCount]=useState([])
  const [vendorReportStatusCount,setVendorReportStatusCount]=useState([])



  useEffect(()=>{
    showGlobalOverlay(true)
    getReportsProjectStatus()
    getReviewerReportStatus()
    getLanguageStatus()
    getFeedBackReportStatus()
    getLanguageStatusTracker()
    getAssestByLanguageStatus()
    getReportsVendorStatus()
    getIntendedUseStatus()
    getWorkItemStatusService()
    getTmProjectReportStatus()
    getTotalWordCountByLanguageStatus()
    getPurchaseOrderStatus()
    totalCostSavingCount()
    purchaseOrderCount()
    getSourceLanguage()
    getProjectReportAssetsCount()
    getTargetLanguage()
    getVendorReportCount()
    showGlobalOverlay(false)
  },[])

  const getProjectReportAssetsCount=()=>{
    getAxiosResponse(APIUrls.PROJECT_REPORT_ASSETS_COUNT).then(res=>{ 
           if(res?.data?.data && res?.data?.data?.length > 0){
            let nestedData = res?.data?.data.reduce((acc, curr) => {
              acc.push([curr.value, curr.totalProject, curr.totalAssets]);
              return acc;
            }, []);
            nestedData.unshift(["value","Project","Assets"])
            setProjectReportAssetsCount(nestedData)
           }
    }).catch(err=>{
      handleError(err)
    }) 
  }

  const getVendorReportCount=()=>{
    getAxiosResponse(APIUrls.VENDOR_REPORT_COUNT).then(res=>{ 
      if(res?.data?.data && res?.data?.data?.length > 0){
        let nestedData = res?.data?.data.reduce((acc, curr) => {
          acc.push([curr.value, curr.amount, curr.rawValue,curr?.profit]);
          return acc;
        }, []);
        nestedData.unshift(["Year", "Sales", "Expenses", "Profit"])
        setVendorReportStatusCount(nestedData)
       }
    }).catch(err=>{
      handleError(err)
    }) 
  }


  const getReportsProjectStatus=()=>{
   getAxiosResponse(APIUrls.PROJECT_BY_STATUS).then(res=>{
    var localCount = 0
     if(res?.data?.data?.reportsChartsFields && res?.data?.data?.reportsChartsFields.length > 0){
     const  data=res?.data?.data?.reportsChartsFields?.map((data,index)=>{
      localCount +=data?.value
          return {
            title:data?.value+" "+data?.label,
            value:data?.value,
            color:data?.colorCode
          }  
      })
     setReportProjectStatus(data)
     setReportProjectStatusCount(localCount)
     }
   }).catch(err=>{
      handleError(err)
   })
  }

  const getReviewerReportStatus=()=>{
    getAxiosResponse(APIUrls.REVIEWER_REPORTS).then(res=>{
       if(res?.data?.data?.reportsChartsFields && res?.data?.data.reportsChartsFields){
        let  nestedArray = res?.data?.data.reportsChartsFields?.map(item => [item.label, item.value])
        .reduce((accumulator, currentValue) => {
           const category = currentValue[0];
           const item = currentValue.slice(1);
           const index = accumulator.findIndex(item => item[0] === category);
           if (index === -1) {
             accumulator.push([category, item[0]]);
           } else {
             accumulator[index][1].push(item);
           }
           return accumulator;
        }, []);
        nestedArray.unshift(["Report","Reviewer based report"])
setReviewerReportStatus(nestedArray)
const options ={
colors:res?.data?.data.reportsChartsFields?.map(item =>item.colorCode),
legend: { textStyle: { color: '#000000', fontSize: 12 } },
}
setReviewerReportOptions(options)
}
}).catch(err=>{
handleError(err)
})
  }

   const  getTargetLanguage=()=>{
      getAxiosResponse(APIUrls.TARGET_LANGUAGE).then(res=>{
        if(res?.data?.data && res?.data?.data?.length){
          const targetLang=res?.data?.data.map(data=>({label:data.display,value:data?.value}))
          setTargetLanguage(targetLang)
        }
      }).catch(err=>{
        handleError(err)
      })
   }

  const getLanguageStatus=()=>{
    getAxiosResponse(APIUrls.LANGUAGE_REPORTS).then(res=>{
       if(res?.data?.data && res?.data?.data?.reportsChartsFields){
        setLanguageStatus(res?.data?.data?.reportsChartsFields)
       }
     }).catch(err=>{
        handleError(err)
     })
  }
  const getFeedBackReportStatus=()=>{
    getAxiosResponse(APIUrls.FEEDBACK_REPORTS).then(res=>{
      if(res?.data?.data.reportsChartsFields && res?.data?.data.reportsChartsFields.length > 0){
      let  nestedArray = res?.data?.data.reportsChartsFields?.map(item => [item.label, item.value])
                       .reduce((accumulator, currentValue) => {
                          const category = currentValue[0];
                          const item = currentValue.slice(1);
                          const index = accumulator.findIndex(item => item[0] === category);
                          if (index === -1) {
                            accumulator.push([category, item[0]]);
                          } else {
                            accumulator[index][1].push(item);
                          }
                          return accumulator;
                       }, []);
                       nestedArray.unshift(["Report","work based feedback Report"])
      setFeedBackReportStatus(nestedArray)
      const options ={
        colors:res?.data?.data.reportsChartsFields?.map(item =>item.colorCode),
        legend: { textStyle: { color: '#000000', fontSize: 12 } },
      }
       setFeedBackReportOption(options)
    }
     }).catch(err=>{
        handleError(err)
     })
    
  }
  const getLanguageStatusTracker=()=>{
    getAxiosResponse(APIUrls.LANGUAGE_STATUS_COUNT_REPORT).then(res=>{
       if(res?.data?.data && res?.data?.data?.reportsChartsFields){
        setLanguageStatusTracker(res?.data?.data?.reportsChartsFields)
       }
     }).catch(err=>{
        handleError(err)
     })
  }
  const getAssestByLanguageStatus=()=>{
    getAxiosResponse(APIUrls.ASSETS_BY_LANGUAGE_COUNT_REPORT).then(res=>{
        if(res?.data?.data && res?.data?.data?.reportsChartsFields){
         setAssestByLanguageStatus(res?.data?.data?.reportsChartsFields)
        }
     }).catch(err=>{
        handleError(err)
     })
  }
  const getReportsVendorStatus=()=>{
    getAxiosResponse(APIUrls.VENDOR_REPORT).then(res=>{
       
     }).catch(err=>{
        handleError(err)
     })
  }

  const getSourceLanguage = () =>{
   getAxiosResponse(APIUrls.SOURCE_LANGUAGE).then(res=>{
     if(res?.data?.data && res?.data?.data?.length > 0){
      const source=res?.data?.data?.map(data=>({
        label:data?.display,
        value:data?.code
      }))
      setSourceLanguage(source)
     }
   }).catch(err=>{
    handleError(err)
   })
  }

  const getIntendedUseStatus=()=>{
    getAxiosResponse(APIUrls.INTENDED_USE_REPORT).then(res=>{
      var localCount = 0
      if(res?.data?.data.reportsChartsFields && res?.data?.data?.reportsChartsFields.length > 0){
      const  data=res?.data?.data?.reportsChartsFields?.map((data,index)=>{
       localCount +=data?.value
           return {
             title:data?.value+" "+data?.label,
             value:data?.value,
             color:data?.colorCode
           }  
       })
      setIntendedUseStatus(data)
      setIntendedUseCount(localCount)
      }
     }).catch(err=>{
        handleError(err)
     })
  }
  const getWorkItemStatusService=()=>{
    getAxiosResponse(APIUrls.WORK_ITEM_STATUS).then(res=>{
      if(res?.data?.data?.reportsChartsFields && res?.data?.data.reportsChartsFields){
        let  nestedArray = res?.data?.data.reportsChartsFields?.map(item => [item.label, item.value])
        .reduce((accumulator, currentValue) => {
           const category = currentValue[0];
           const item = currentValue.slice(1);
           const index = accumulator.findIndex(item => item[0] === category);
           if (index === -1) {
             accumulator.push([category, item[0]]);
           } else {
             accumulator[index][1].push(item);
           }
           return accumulator;
        }, []);
        nestedArray.unshift(["Report","Work item based report"])
        setWorkItemStatus(nestedArray)
const options ={
colors:res?.data?.data.reportsChartsFields?.map(item =>item.colorCode),
legend: { textStyle: { color: '#000000', fontSize: 12 } },
}
setWorkItemOptions(options)
}
}).catch(err=>{
handleError(err)
})
  }
  const getTmProjectReportStatus=()=>{
    getAxiosResponse(APIUrls.TM_PROJECT_REPORT_STATUS).then(res=>{
      var localCount = 0
      if(res?.data?.data.reportsChartsFields && res?.data?.data?.reportsChartsFields.length > 0){
      const  data=res?.data?.data?.reportsChartsFields?.map((data,index)=>{
       localCount +=data?.value
           return {
             title:data?.value+" "+data?.label,
             value:data?.value,
             color:data?.colorCode
           }  
       })
       setTmProjectReportStatus(data)
      setTmProjectReportCount(localCount)
      }
     }).catch(err=>{
        handleError(err)
     })
  }
  const getTotalWordCountByLanguageStatus=()=>{
    getAxiosResponse(APIUrls.TOTAL_WORD_COUNT_LANGUAGE_STATUS).then(res=>{
      if(res?.data?.data.reportsChartsFields && res?.data?.data?.reportsChartsFields.length > 0){
       setTotalWordCountByLanguageStatus(res?.data?.data?.reportsChartsFields)
      }
     }).catch(err=>{
        handleError(err)
     })
  }
  const getPurchaseOrderStatus=()=>{
    getAxiosResponse(APIUrls.PURCHASE_ORDER_REPORT).then(res=>{
      setPurchaseOrderInvoic(res?.data?.data)
     }).catch(err=>{
        handleError(err)
     })
  }
  const totalCostSavingCount=()=>{
    getAxiosResponse(APIUrls.TOTAL_COST_SAVING_REPORT).then(res=>{
       setTotalCostSavingCount(res.data.data)
    }).catch(err=>{
        handleError(err)
     })
  }
  const purchaseOrderCount=()=>{
    getAxiosResponse(APIUrls.PURCHASE_ORDER_STATUS_REPORT).then(res=>{
      setPurchaseOrderStatus(res.data.data)
     }).catch(err=>{
        handleError(err)
     })
  }

  const defaultLabelStyle = {
    fontSize: "4px",
    fontFamily: "sans-serif",
    fill: "#FFFFFF",
  };

  const vendorObject = {
    chart: {
      title: "Vendor",
    },
  };

  const [focusedData, setFocusedData] = useState(null);

  const handleFocus = (chartWrapper) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();

    if (selection.length > 0) {
      const { row, column } = selection[0];
      setFocusedData({ row, column });
    }
  };

  const handleBlur = () => {
    setFocusedData(null);
  };  
   const options = {
    hAxis: { title: "Value", titleTextStyle: { color: "#333" } },
    vAxis: { minValue: 0 },
    chartArea: { width: "50%", height: "70%" },
  };


  return (

    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="white-bg mh-550 mar-bot50">
              <div className="vender-edit-page Report-page">
                <div className="vender-heading">
                  <h4>Reports</h4>
                </div>
                <div className="listing-tab-block flex">
                    <ul className="listing-tab-link flex">
                        <li><button
                           className={activeTab === "ProjectDashboard" ? "active" : ""}
                           onClick={() => setActiveSection("ProjectDashboard")}
                          >Project dashboard</button></li>
                        <li><button
                           className={activeTab === "operationalCost" ? "active" : ""}
                           onClick={() => setActiveSection("operationalCost")}
                         
                        >Operational Cost</button></li>
                        <li><button
                          className={activeTab === "TMDashboard" ? "active" : ""}
                          onClick={() => setActiveSection("TMDashboard")}
                        >TM Dashboard</button></li>
                    </ul>
                </div>
                <div className="report-content">
                   <div className="flex justify-end space-gap mar-bot25">
                    <div className="radio-form-check mb-0">
                      <input type="radio" className="form-check-input" name="radio" id="quaterview" checked />
                      <label className="form-check-label" for="quaterview">
                        Quaterly View
                      </label>
                    </div>
                    <div className="radio-form-check mb-0">
                      <input type="radio" className="form-check-input" name="radio" id="yearlyview" />
                      <label className="form-check-label" for="yearlyview">
                        Yearly View
                      </label>
                    </div>
                   </div>
                   <div className={activeTab === "ProjectDashboard" ? "Projectdashboard-tab-content show" : "hide"}>
                      <div className="flex space-gap">
                        <div className="left-report">
                           <div className="top-block flex space-gap">
                             <div className="project-status report-border">
                               <div className="flex gap20 report-heading">
                                 <h5>Projects by Status</h5>
                                 <button className="inline-flex" aria-label="filter">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                 </svg>
                                 </button>
                               </div>
          
                               <div className="pie-chart flex flex-align-center">
                                 <div className="chartBox">
                                    <div className="pieTotalCount">
                                      <span>{reportProjectStatusCount}</span>
                                      <strong>Projects</strong>
                                    </div>
                                    <PieChart
              radius={35}
              data={reportProjectStatus}
              segmentsTabIndex={0}
              center={[40, 50]}
              viewBoxSize={[100, 100]}
              lineWidth={40}
              totalValue={reportProjectStatusCount}
              labelPosition={78}
               label={({ dataEntry }) => `${Math.floor(dataEntry.percentage)} %`}
              labelStyle={{
                ...defaultLabelStyle,
              }}></PieChart>
              
                                 </div>
                                 <div className="clorList">
                                    <ul>
                                      {reportProjectStatus.map(data=>(
                                        <li><span style={{background: data?.color}}> </span><small>{data?.title}</small></li>
                                      ))}
                                    </ul>
                                </div>
                               </div>
                             </div>
                             <div className="reviewer-status report-border">
                               <div className="flex gap20 mar-bot25 report-heading">
                                  <h5>Reviewer Report</h5>
                                  <button className="inline-flex" aria-label="filter">
                                   <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                 </button>
                               </div>
                               <div className="review-chart">
                               <Chart
                                      chartType="PieChart"
                                      data={reviewerReportStatus}
                                      options={reviewerReportOptions}
                                      width="100%"
                                      height="400px"
                                    />
                                </div>
                                  
                             </div>
                           </div>
                           <div className="bottom-block flex space-gap">
                             <div className="feedback-reports report-border">
                               <div className="flex gap20 mar-bot25 report-heading">
                                 <h5>Feedback Reports</h5>
                                 <button className="inline-flex" aria-label="filter">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                 </svg>
                                 </button>
                               </div>
                               <div className="pie-chart flex flex-align-center">
                                 <div className="chartBox">
                                   {/* <svg xmlns="http://www.w3.org/2000/svg" width="196" height="196" viewBox="0 0 196 196" fill="none">
                                     <circle cx="98" cy="98" r="98" fill="#70B6C1"/>
                                  </svg> */}

                                <Chart
                                      chartType="PieChart"
                                      data={feedBackReportStatus}
                                      options={feedBackReportOptions}
                                      width="100%"
                                      height="400px"
                                    />
                                 </div>
                               </div>
                             </div>
                             <div className="lang-status report-border">
                               <div className="flex gap20 mar-bot25 report-heading">
                                 <h5>Language Status</h5>
                                 <button className="inline-flex" aria-label="filter">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                 </svg>
                                 </button>
                               </div>
                               <div className="lang-progress">
                                {languageStatus.map(data=>(
                                 <div className="lang-progress-list flex">
                                 <span>{data?.label}</span>
                                 <div className="right flex-center">
                                    <div className="circle-progress flex">
                                      <CircularProgress variant="determinate"   size={30} thickness={5} value={data?.value} style={{color: "#457F88"}}/>
                                    </div>&nbsp;
                                    <strong>{data?.value}%</strong>
                                 </div>
                               </div>
                                ))}
                               </div>
                             </div>
                           </div>
                        </div>
                        <div className="right-status">
                          <div className="delivery-status report-border">
                             <div className="flex gap20 mar-bot25 report-heading">
                                 <h5>Language Status</h5>
                              </div>
                              <ul className="report-order-list">
                                {languageStatusTracker.map(data=>(
                                <li>
                                <span>{data?.label}</span>
                                <strong style={{color: data?.colorCode}}>{data?.value}</strong>
                              </li>
                                ))}
                              </ul>
                          </div>
                          <div className="delivery-status assests-lang report-border">
                             <div className="flex gap20 mar-bot25 report-heading">
                                 <h5>Assest by Language</h5>
                              </div>
                              <ul>
                                {assestByLanguageStatus.map(data=>(
                                <li>
                                <span>{data?.label}</span>
                                <strong>{data?.value}</strong>
                              </li>
                                ))}
                              </ul>
                          </div>
                        </div>
                      </div>
                   </div>
                   <div className={activeTab === "operationalCost" ? "operational-tab-content show" : "hide"}>
                   <div className="flex space-gap">
                        <div className="left-report">
                           <div className="top-block flex space-gap">
                             <div className="project-status report-border">
                               <div className="flex gap20 report-heading">
                                 <h5>Intended Use</h5>
                                 <button className="inline-flex" aria-label="filter">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                 </svg>
                                 </button>
                               </div>
                               <div className="pie-chart flex flex-align-center">
                                 <div className="chartBox">
                                    <div className="pieTotalCount">
                                      <span>${intendedUseCount}</span>
                                      <strong>TOTAL</strong>
                                    </div>
                                    <PieChart
              radius={35}
              data={intendedUseStatus}
              segmentsTabIndex={0}
              center={[40, 50]}
              viewBoxSize={[100, 100]}
              lineWidth={40}
              totalValue={intendedUseCount}
              labelPosition={78}
               label={({ dataEntry }) => `${Math.floor(dataEntry.percentage)} %`}
              labelStyle={{
                ...defaultLabelStyle,
              }}></PieChart>
                                 </div>
                                 <div className="clorList">
                                    <ul>
                                    {intendedUseStatus.map(data=>(
                                        <li><span style={{background: data.color}}> </span><small>{data.title}</small></li>
                                      ))}
                                    </ul>
                                </div>
                               </div>
                             </div>
                             <div className="reviewer-status report-order-item report-border">
                               <div className="flex mar-bot25 report-heading">
                                  <h5>Purchase Order</h5>
                               </div>
                               <div className="total-order">
                                 <span>TOTAL PURCHASE ORDER</span>
                                 <strong>{purchaseOrderDataInvoice?.total}</strong>
                               </div>
                               <ul className="report-order-list">
                                <li>
                                  <span>Invoice Sent</span>
                                  <strong>{purchaseOrderDataInvoice?.invoiceSent}</strong>
                                </li>
                                <li>
                                  <span>Invoice Not Sent</span>
                                  <strong>{purchaseOrderDataInvoice?.invoiceNotSent}</strong>
                                </li>
                                <li>
                                  <span>Invoice Paid</span>
                                  <strong>{purchaseOrderDataInvoice?.invoicePaid}</strong>
                                </li>
                               </ul>
                                  
                             </div>
                           </div>
                           <div className="bottom-block flex space-gap">
                             <div className="vender-reports report-border">
                               <div className="flex gap20 mar-bot25 report-heading">
                                 <h5>Vendors</h5>
                                 <button className="inline-flex" aria-label="filter">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                 </svg>
                                 </button>
                               </div>
                               <div className="vender-grap">
                               <Chart
      chartType="Bar"
      width="100%"
      height="400px"
      data={vendorReportStatusCount}
      options={vendorObject}
    />
                               </div>
                             </div>
                             <div className="feedback-reports report-border">
                               <div className="flex gap20 mar-bot25 report-heading">
                                 <h5>Work Item</h5>
                                 <button className="inline-flex">
                                  <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                    <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                 </svg>
                                 </button>
                               </div>
                               <div className="pie-chart flex flex-align-center">
                               <Chart
                                      chartType="PieChart"
                                      data={workItemStatus}
                                      options={workItemOptions}
                                      width="100%"
                                      height="400px"
                                    />
                               </div>
                             </div>
                           </div>
                        </div>
                        <div className="right-status">
                          <div className="lang-progress report-border">
                              <div className="mar-bot25 report-heading">
                                 <h5>Language</h5>
                              </div>
                              <div className="flex wrap-dropdown mar-bot20">
                                <div className="global-dropdown-block w-d100">
                                  <label>What is your source language?</label>
                                  <Select
                                      classNamePrefix='cw'
                                      className="global-dropdown-select"
                                      menuShouldScrollIntoView={false}
                                      closeMenuOnSelect={true} 
                                      options={sourceLanguage}
                                      defaultValue={{ label: 'Select Language' }}
                                  />
                                </div>
                              </div>
                              <div className="lang-progress-block">
                                 {totalWordCountByLanguageStatus?.map(data=>(
                                  <div className="lang-progress-list">
                                   <div className="lang-name flex justify-center">
                                      <span>{data?.label}</span>
                                      <strong>{data?.value}</strong>
                                   </div>
                                   <div className="lang-progress-bar">
                                   <BorderLinearProgress variant="determinate" value={50} />
                                   </div>
                                 </div>
                                 ))}
                              </div>
                            
                          </div>
                          
                        </div>
                      </div>
                   </div>
                   <div className={activeTab === "TMDashboard" ? "TMDashboard-tab-content show" : "hide"}>
                     <div className="top-block flex space-gap">
                        <div className="word-count report-border">
                            <div className="flex gap20 mar-bot30 report-heading">
                                <h5>Word Count</h5>
                                <button className="inline-flex" aria-label="filter">
                                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                  <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </button>
                            </div>
                            <div className="word-count-graph">
                            <Chart
      chartType="AreaChart"
      width="100%"
      height="400px"
      data={projectReportAssetsCount}
      options={options}
    />
                            </div>
                        </div>
                        <div className="total-wordcount-lang report-border">
                             <div className="flex gap20 mar-bot30 report-heading">
                                <h5>Total Word Count By Language</h5>
                                <button className="inline-flex" aria-label="filter">
                                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                  <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </button>
                              </div>
                              <div className="flex wrap-dropdown mar-bot20">
                                <div className="global-dropdown-block w-d100">
                                  <label>Select Language to see status</label>
                                  <Select
                                      classNamePrefix='cw'
                                      className="global-dropdown-select"
                                      menuShouldScrollIntoView={false}
                                      closeMenuOnSelect={true} 
                                      defaultValue={{ label: 'Select Language' }}
                                      options={targetLanguage}
                                  />
                                </div>
                              </div>
                              <ul className="report-order-list">
                              {totalWordCountByLanguageStatus.map(data=>(
                                <li>
                                  <span>{data?.label}</span>
                                  <strong>{data?.value}</strong>
                                </li>
                              ))}
                              </ul>
                        </div>
                        <div className="total-word-count">
                            <div className="report-order-item report-border mar-bot20">
                              <div className="flex mar-bot20 report-heading">
                                  <h5>Purchase Order</h5>
                               </div>
                               <div className="total-order mb-0">
                                 <span>TOTAL WORD COUNT IN TM</span>
                                 <strong>{purchaseOrderStatus?.value}</strong>
                               </div>
                            </div>
                            <div className="report-order-item report-border">
                              <div className="flex mar-bot20 report-heading">
                                  <h5>Total Cost Saving</h5>
                               </div>
                               <div className="total-order mb-0">
                                 <span>TOTAL WORD SAVING IN TM</span>
                                 <strong>{totalCostSaving?.value}</strong>
                               </div>
                            </div>
                        </div>
                     </div>
                     <div className="bottom-block flex space-gap">
                        <div className="project-status report-border">
                            <div className="flex gap20 report-heading">
                              <h5>Projects by Status</h5>
                              <button className="inline-flex" aria-label="filter">
                              <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              </button>
                            </div>
                            <div className="pie-chart flex flex-align-center">
                              <div className="chartBox">
                                <div className="pieTotalCount">
                                  <span>{tmProjectReportCount}</span>
                                  <strong>Projects</strong>
                                </div>
                                <PieChart
              radius={35}
              data={tmProjectReportStatus}
              segmentsTabIndex={0}
              center={[40, 50]}
              viewBoxSize={[100, 100]}
              lineWidth={40}
              totalValue={tmProjectReportCount}
              labelPosition={78}
               label={({ dataEntry }) => `${Math.floor(dataEntry.percentage)} %`}
              labelStyle={{
                ...defaultLabelStyle,
              }}></PieChart>
                              </div>
                              <div className="clorList">
                                <ul>
                                  {tmProjectReportStatus.map(data=>(
                                    <li><span style={{background: data?.color}}> </span><small>{data?.title}</small></li>
                                  ))}
                                </ul>
                            </div>
                            </div>
                            
                          </div>
                          <div className="word-count report-border">
                            <div className="flex gap20 mar-bot30 report-heading">
                                <h5>Language Fluctuations</h5>
                                <button className="inline-flex" aria-label="filter">
                                <svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="19" height="17" viewBox="0 0 19 17" fill="none">
                                  <path d="M18 1H1L7.8 8.88333V14.3333L11.2 16V8.88333L18 1Z" stroke="#64748B" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </button>
                            </div>
                            <div className="conditional-graph flex mar-bot20">
                               <button className="blue-btn">Daily</button>
                               <button className="blue-btn active">Weekly</button>
                               <button className="blue-btn">Monthly</button>
                               <button className="blue-btn">Yearly</button>
                            </div>
                            <div className="word-count-graph">
                            <Chart
      chartType="AreaChart"
      width="100%"
      height="400px"
      data={projectReportAssetsCount}
      options={options}
    />
                            </div>
                         </div>
                     </div>
                   </div>
                </div>
              </div>
        
            </div>
          </div>
        </section>
      </div>
      <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>  
    </div>
  );
}
